// extracted by mini-css-extract-plugin
module.exports = {"content":"content--3ORjU","sider_wrapper":"sider_wrapper--1Fcn2","logo":"logo--fyZC1"};